import { ChevronRight } from '@/components/icons';
import styles from './css/FloatingButton.module.css';

interface FloatingButtonProps {
  handleClick: () => void;
}

export default function FloatingButton({ handleClick }: FloatingButtonProps) {
  return (
    <button className={`btn ${styles.floatingBtn}`} type="submit" onClick={handleClick}>
      <div className="flex flex-col flex-grow items-start">
        <span className="block text-lg font-semibold">Make a reservation</span>
        <span className="block text-sm font-normal font-inter">When would you want to go to this tour?</span>
      </div>
      <ChevronRight />
    </button>
  );
}
